import VueGtag, { bootstrap, optOut, event, set } from "vue-gtag";
import { defineNuxtPlugin, useRuntimeConfig, useNuxtApp, useRouter } from "#app";
import { watch } from "vue";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const { $device } = useNuxtApp();
  if (config.public.gaId) {
    nuxtApp.vueApp.use(VueGtag, {
      config: {
        id: config.public.gaId,
        params: {
          anonymize_ip: true,
          debug_mode: config.public.debug ?? false
        }
      },
      bootstrap: false,
      // @ts-ignore - method is not correctly typed on the plugin
      pageTrackerTemplate(to) {
        return {
          page_title: document.title,
          page_path: to.path
        };
      }
    }, useRouter());
  }
  const enable = () => {
    if (config.public.gaId) {
      bootstrap().then((gtag) => {
      });
    }
  };
  const disable = () => {
    optOut();
  };
  const trackEvent = (name, data = {}) => {
    event(name, data);
  };
  const trackQmnPageImpression = () => {
    const formatTag = $device.isMobile ? "mobile" : "desktop";
    const tcpAmount = $device.isMobile ? 7.01 : 9.57;
    event("ad_load", {
      ad_platform: "Quality Media Network",
      ad_source: "Quality Media Network",
      ad_unit_name: `qmn_${formatTag}_full_page`,
      ad_format: "full_page",
      value: tcpAmount / 1e3,
      currency: "EUR"
    });
  };
  if (nuxtApp.$auth) {
    watch(() => nuxtApp.$auth.user, (user) => {
      let userRole = "guest";
      if (user) {
        if (user.roles.includes("admin")) {
          userRole = "admin";
        } else {
          userRole = "user";
        }
      }
      set({
        user_properties: {
          role: userRole
        }
      });
    }, { immediate: nuxtApp.$auth.initialized });
  }
  return {
    provide: {
      analytics: {
        enable,
        disable,
        trackEvent,
        trackQmnPageImpression
      }
    }
  };
});
